import type { ListParams } from '../type';
import baseKey from './_baseKey';

const clientDomainKey = (clientSubDomains?: string[]) =>
  baseKey.domainKey('client', clientSubDomains);

/**
 * 고객사 관련 쿼리키 제너레이터
 */
const clientKey = {
  /**
   * @returns 고객사 도메인 기본 쿼리키 (getter)
   * @example ['client']
   */
  domain() {
    return clientDomainKey();
  },
  /**
   * @returns 전체 고객사 리스트 요청 쿼리키
   * @example ['client', 'list', 'all']
   */
  listAll() {
    return [...baseKey.listKey(clientDomainKey(), 'all')];
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 페이지네이션 방식 고객사 리스트 요청 쿼리키
   * @example ['client', 'list', 'page', {...listParams}]
   */
  listByPage(listParams?: ListParams) {
    const coreKey = baseKey.listKey(clientDomainKey(), 'page');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 무한 스크롤 방식 고객사 리스트 요청 쿼리키
   * @example ['client', 'list', 'scroll', {...listParams}]
   */
  listByScroll(listParams?: ListParams) {
    const coreKey = baseKey.listKey(clientDomainKey(), 'scroll');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  /**
   * 👉🏻 대시보드 패널에서 사용 중
   * @param listParams 리스트 파라미터
   * @returns 지점 리스트를 포함한 무한 스크롤 방식 고객사 리스트 요청 쿼리키
   * @example ['client', 'venue', 'list', 'scroll', {...listParams}]
   */
  listWithVenueListByScroll(listParams?: ListParams) {
    const coreKey = baseKey.listKey(clientDomainKey(['venue']), 'scroll');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  /**
   * @param id 고객사 리스트 아이템 ID
   * @returns ID에 대하는 고객사 상세 데이터 요청 쿼리키
   * @example ['client', 'detail', 1]
   */
  detailById(id: number) {
    return [...baseKey.itemKey(clientDomainKey(), 'detail'), id];
  },
  /**
   * 👉🏻 대시보드 패널에서 사용 중
   * @param bizNumber 사업자등록번호
   * @returns 주어진 사업자등록번호에 해당하는 고객사 데이터 개수 요청 쿼리키
   * @example ['client', 'count', '416-87-01054']
   */
  countByBizNumber(bizNumber: string) {
    return [...baseKey.countKey(clientDomainKey()), bizNumber];
  },
};

export default Object.freeze(clientKey);
